import {VideoSubEvent} from "../../../constants/Janus/VideoRoom/Subscriber";

export const attachVRoomSub = (Janus: any, janus: any, opaqueId: string, room: number, secret: string | undefined, pin: string | undefined, username: string, isPublisher: boolean, callback: any) => {
    let pubPlugin: any = null;
    let myStream: any = null;

    if (!janus) {
        return;
    }


}

export function newRemoteFeed(Janus: any, janus: any, opaqueId: any, room: number, id: number, pvtId: number, display: any, audio: any, video: any, callback: any) {
    let remoteFeed: any = null;

    if (!janus) {
        return;
    }

    janus.attach(
        {
            plugin: "janus.plugin.videoroom",
            opaqueId: opaqueId,
            success: function(pluginHandle: any) {
                remoteFeed = pluginHandle;
                remoteFeed.simulcastStarted = false;
                Janus.log("Plugin attached! (" + remoteFeed.getPlugin() + ", id=" + remoteFeed.getId() + ")");
                Janus.log("  -- This is a subscriber");
                // We wait for the plugin to send us an offer
                let subscribe = {
                    request: "join",
                    room: room,
                    ptype: "subscriber",
                    feed: id,
                    private_id: pvtId,
                    offer_video: true,
                };
                // In case you don't want to receive audio, video or data, even if the
                // publisher is sending them, set the 'offer_audio', 'offer_video' or
                // 'offer_data' properties to false (they're true by default), e.g.:
                // 		subscribe["offer_video"] = false;
                // For example, if the publisher is VP8 and this is Safari, let's avoid video
                if(Janus.webRTCAdapter.browserDetails.browser === "safari" &&
                    (video === "vp9" || (video === "vp8" && !Janus.safariVp8))) {
                    if(video)
                        video = video.toUpperCase()
                    // toastr.warning("Publisher is using " + video + ", but Safari doesn't support it: disabling video");
                    subscribe.offer_video = false;
                }
                remoteFeed.videoCodec = video;
                remoteFeed.send({ message: subscribe });
                callback(remoteFeed, VideoSubEvent.SUCCESS)
            },
            error: function(error: any) {
                Janus.error("  -- Error attaching plugin...", error);
                // bootbox.alert("Error attaching plugin... " + error);
                callback(remoteFeed, VideoSubEvent.ERROR, error);
            },
            onmessage: function(msg: any, jsep: any) {
                Janus.debug(" ::: Got a message (subscriber) :::", msg);
                let event = msg["videoroom"];
                Janus.debug("Event: " + event);
                if(msg["error"]) {
                    // bootbox.alert(msg["error"]);
                    callback(remoteFeed, VideoSubEvent.ERROR, msg);
                } else if(event) {
                    if(event === "attached") {
                        // Subscriber created and attached
                        // for(var i=1;i<6;i++) {
                        //     if(!feeds[i]) {
                        //         feeds[i] = remoteFeed;
                        //         remoteFeed.rfindex = i;
                        //         break;
                        //     }
                        // }
                        remoteFeed.rfid = msg["id"];
                        remoteFeed.rfdisplay = msg["display"];
                        // remoteFeed.rfdisplay = escapeXmlTags(msg["display"]);
                        // if(!remoteFeed.spinner) {
                        //     var target = document.getElementById('videoremote'+remoteFeed.rfindex);
                        //     remoteFeed.spinner = new Spinner({top:100}).spin(target);
                        // } else {
                        //     remoteFeed.spinner.spin();
                        // }
                        Janus.log("Successfully attached to feed " + remoteFeed.rfid + " (" + remoteFeed.rfdisplay + ") in room " + msg["room"]);
                        // $('#remote'+remoteFeed.rfindex).removeClass('hide').html(remoteFeed.rfdisplay).show();
                        callback(remoteFeed, VideoSubEvent.ATTACHED);
                    } else if(event === "event") {
                        // Check if we got a simulcast-related event from this publisher
                        let substream = msg["substream"];
                        let temporal = msg["temporal"];
                        if(!substream || !temporal) {
                            // if(!remoteFeed.simulcastStarted) {
                            //     remoteFeed.simulcastStarted = true;
                            //     // Add some new buttons
                            //     addSimulcastButtons(remoteFeed.rfindex, remoteFeed.videoCodec === "vp8");
                            // }
                            // // We just received notice that there's been a switch, update the buttons
                            // updateSimulcastButtons(remoteFeed.rfindex, substream, temporal);
                        }
                        callback(remoteFeed, VideoSubEvent.EVENT);
                    } else {
                        // What has just happened?
                    }
                }
                if(jsep) {
                    Janus.debug("Handling SDP as well...", jsep);
                    let stereo = (jsep.sdp.indexOf("stereo=1") !== -1);
                    // Answer and attach
                    remoteFeed.createAnswer(
                        {
                            jsep: jsep,
                            // Add data:true here if you want to subscribe to datachannels as well
                            // (obviously only works if the publisher offered them in the first place)
                            media: { audioSend: false, videoSend: false },	// We want recvonly audio/video
                            customizeSdp: function(jsep: any) {
                                if(stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                                    // Make sure that our offer contains stereo too
                                    jsep.sdp = jsep.sdp.replace("useinbandfec=1", "useinbandfec=1;stereo=1");
                                }
                            },
                            success: function(jsep: any) {
                                Janus.debug("Got SDP!", jsep);
                                let body = { request: "start", room };
                                remoteFeed.send({ message: body, jsep: jsep });
                            },
                            error: function(error: any) {
                                Janus.error("WebRTC error:", error);
                                // bootbox.alert("WebRTC error... " + error.message);
                            }
                        });
                }
            },
            iceState: function(state: any) {
                Janus.log("ICE state of this WebRTC PeerConnection (feed #" + remoteFeed.rfindex + ") changed to " + state);
                callback(remoteFeed, VideoSubEvent.ICE_STATE, state);
            },
            webrtcState: function(on: boolean) {
                Janus.log("Janus says this WebRTC PeerConnection (feed #" + remoteFeed.rfindex + ") is " + (on ? "up" : "down") + " now");
                callback(remoteFeed, VideoSubEvent.WEBRTC_STATE, on);
            },
            onlocalstream: function(stream: any) {
                // The subscriber stream is recvonly, we don't expect anything here
            },
            onremotestream: function(stream: any) {
                Janus.debug("Remote feed #" + remoteFeed.rfindex + ", stream:", stream);
                // let addButtons = false;
                // if($('#remotevideo'+remoteFeed.rfindex).length === 0) {
                //     addButtons = true;
                //     // No remote video yet
                //     $('#videoremote'+remoteFeed.rfindex).append('<video class="rounded centered" id="waitingvideo' + remoteFeed.rfindex + '" width="100%" height="100%" />');
                //     $('#videoremote'+remoteFeed.rfindex).append('<video class="rounded centered relative hide" id="remotevideo' + remoteFeed.rfindex + '" width="100%" height="100%" autoplay playsinline/>');
                //     $('#videoremote'+remoteFeed.rfindex).append(
                //         '<span class="label label-primary hide" id="curres'+remoteFeed.rfindex+'" style="position: absolute; bottom: 0px; left: 0px; margin: 15px;"></span>' +
                //         '<span class="label label-info hide" id="curbitrate'+remoteFeed.rfindex+'" style="position: absolute; bottom: 0px; right: 0px; margin: 15px;"></span>');
                //     // Show the video, hide the spinner and show the resolution when we get a playing event
                //     $("#remotevideo"+remoteFeed.rfindex).bind("playing", function () {
                //         if(remoteFeed.spinner)
                //             remoteFeed.spinner.stop();
                //         remoteFeed.spinner = null;
                //         $('#waitingvideo'+remoteFeed.rfindex).remove();
                //         if(this.videoWidth)
                //             $('#remotevideo'+remoteFeed.rfindex).removeClass('hide').show();
                //         var width = this.videoWidth;
                //         var height = this.videoHeight;
                //         $('#curres'+remoteFeed.rfindex).removeClass('hide').text(width+'x'+height).show();
                //         if(Janus.webRTCAdapter.browserDetails.browser === "firefox") {
                //             // Firefox Stable has a bug: width and height are not immediately available after a playing
                //             setTimeout(function() {
                //                 var width = $("#remotevideo"+remoteFeed.rfindex).get(0).videoWidth;
                //                 var height = $("#remotevideo"+remoteFeed.rfindex).get(0).videoHeight;
                //                 $('#curres'+remoteFeed.rfindex).removeClass('hide').text(width+'x'+height).show();
                //             }, 2000);
                //         }
                //     });
                // }
                // Janus.attachMediaStream($('#remotevideo'+remoteFeed.rfindex).get(0), stream);
                // var videoTracks = stream.getVideoTracks();
                // if(!videoTracks || videoTracks.length === 0) {
                //     // No remote video
                //     $('#remotevideo'+remoteFeed.rfindex).hide();
                //     if($('#videoremote'+remoteFeed.rfindex + ' .no-video-container').length === 0) {
                //         $('#videoremote'+remoteFeed.rfindex).append(
                //             '<div class="no-video-container">' +
                //             '<i class="fa fa-video-camera fa-5 no-video-icon"></i>' +
                //             '<span class="no-video-text">No remote video available</span>' +
                //             '</div>');
                //     }
                // } else {
                //     $('#videoremote'+remoteFeed.rfindex+ ' .no-video-container').remove();
                //     $('#remotevideo'+remoteFeed.rfindex).removeClass('hide').show();
                // }
                // if(!addButtons)
                //     return;
                // if(Janus.webRTCAdapter.browserDetails.browser === "chrome" || Janus.webRTCAdapter.browserDetails.browser === "firefox" ||
                //     Janus.webRTCAdapter.browserDetails.browser === "safari") {
                //     $('#curbitrate'+remoteFeed.rfindex).removeClass('hide').show();
                //     bitrateTimer[remoteFeed.rfindex] = setInterval(function() {
                //         // Display updated bitrate, if supported
                //         var bitrate = remoteFeed.getBitrate();
                //         $('#curbitrate'+remoteFeed.rfindex).text(bitrate);
                //         // Check if the resolution changed too
                //         var width = $("#remotevideo"+remoteFeed.rfindex).get(0).videoWidth;
                //         var height = $("#remotevideo"+remoteFeed.rfindex).get(0).videoHeight;
                //         if(width > 0 && height > 0)
                //             $('#curres'+remoteFeed.rfindex).removeClass('hide').text(width+'x'+height).show();
                //     }, 1000);
                // }
                callback(remoteFeed, VideoSubEvent.ON_REMOTE_STREAM, stream);
            },
            oncleanup: function() {
                Janus.log(" ::: Got a cleanup notification (remote feed " + id + ") :::");
                callback(remoteFeed, VideoSubEvent.ON_CLEAN_UP);
                // if(remoteFeed.spinner)
                //     remoteFeed.spinner.stop();
                // remoteFeed.spinner = null;
                // $('#remotevideo'+remoteFeed.rfindex).remove();
                // $('#waitingvideo'+remoteFeed.rfindex).remove();
                // $('#novideo'+remoteFeed.rfindex).remove();
                // $('#curbitrate'+remoteFeed.rfindex).remove();
                // $('#curres'+remoteFeed.rfindex).remove();
                // if(bitrateTimer[remoteFeed.rfindex])
                //     clearInterval(bitrateTimer[remoteFeed.rfindex]);
                // bitrateTimer[remoteFeed.rfindex] = null;
                // remoteFeed.simulcastStarted = false;
                // $('#simulcast'+remoteFeed.rfindex).remove();
            }
        });
}